////////GHG EF 2.2 Schema
const twoTwoSchema = {
  title: "2.2 Indirect Emissions from Purchased/Acquired Steam",
  cat: "2_2",
  catName: "cat2",
  progressiveOrderSwitch: {
    by: { level: 3, key: "computationMethod" }, // 觀察誰
  },
  fields: [
    {
      key: "title",
      type: "title",
      title: "Emission Factor",
      specialDataShouldIf: {
        level: 1,
        key: "activityId",
        notEmpty: true,
        formData: "EAFormData",
      },
    },
    ////////Data Source (emissionFactorTypeId)
    {
      key: "emissionFactorTypeId",
      level: 2,
      type: "select",
      label: "Data Source",
      optionsAPI: "emissionFactorDropdown",
      autoFillNum: 0,
      specialDataShouldIf: {
        level: 1,
        key: "activityId",
        notEmpty: true,
        formData: "EAFormData",
      },
    },
    ////////Method of Calculation
    {
      key: "computationMethod",
      level: 3,
      type: "select",
      label: "Method of Calculation",
      optionsAPI: "emissionLevel",
      showIf: {
        all: [
          { level: 2, key: "emissionFactorTypeId", ne: "2" },
          { level: 2, key: "emissionFactorTypeId", notEmpty: true },
        ],
      },
      combineKey: 1,
    },
    ////////Emission Factor Database Source (sourceEFName)
    {
      key: "sourceEFName",
      level: 4,
      type: "select",
      label: "Emission Factor Database Source",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 3,
        key: "computationMethod",
      },
      showIf: {
        level: 3,
        key: "computationMethod",
        notEmpty: true,
      },
      combineKey: 2,
    },
    //////// Fuel Type (emissionLevel) [Method of Calculation = Fuel Based]
    {
      key: "fuelType2_2",
      level: 5,
      type: "select",
      label: "Fuel Type",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 4,
        key: "sourceEFName",
      },
      showIf: {
        all: [
          { level: 3, key: "computationMethod", ne: "Energy Based" },
          { level: 4, key: "sourceEFName", notEmpty: true },
        ],
      },
      combineKey: 3,
    },
    //////// Fuel Name (emissionFactorId) [Method of Calculation = Fuel Based]
    {
      key: "emissionFactorId",
      level: 6,
      type: "select",
      label: "Fuel Name",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 5,
        key: "fuelType2_2",
      },
      showIf: {
        all: [
          { level: 3, key: "computationMethod", ne: "Energy Based" },
          { level: 5, key: "fuelType2_2", notEmpty: true },
        ],
      },
      combineKey: 4,
    },
    //////// Energy Type
    {
      key: "emissionFactorId",
      level: 6,
      type: "select",
      label: "Energy Type",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 4,
        key: "sourceEFName",
      },
      showIf: {
        all: [
          { level: 3, key: "computationMethod", ne: "Fuel Based" },
          { level: 4, key: "sourceEFName", notEmpty: true },
        ],
      },
      combineKey: 3,
    },
    ////////Emission Factor Name (自定義)
    {
      key: "emissionFactorId",
      addBtn: true,
      level: 6,
      type: "select",
      custom: true,
      label: "Emission Factor Name",
      optionsAPI: "cat1CustomEFDropdownList",
      showIf: {
        level: 2,
        key: "emissionFactorTypeId",
        eq: "2",
      },
      autoFillNum: 0,
    },
  ],
};

export default twoTwoSchema;
